package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.core.network.EnvironmentConfig
import br.com.texeratx.boardgametimeapp.core.network.KtorHttpClient
import org.koin.core.qualifier.named
import org.koin.dsl.module

val networkModule = module {
    single(named("apiBaseUrl")) { EnvironmentConfig.API_BASE_URL.removeSuffix("/") }
    single { KtorHttpClient.client }
    single { ApiClient(get(), get(), get(named("apiBaseUrl"))) }

}
